export enum BackupSourceType {
  COUPANG = 'coupang',
  NAVER = 'naver',
}

// Filled by the scrape job; absent/null means not yet scraped.
export const BACKUP_SOURCE_STATUSES = ['instock', 'outofstock', 'obsolete', 'error'] as const;
export type BackupSourceStatus = (typeof BACKUP_SOURCE_STATUSES)[number];

export interface BackupSource {
  source: BackupSourceType;
  url: string;
  status?: BackupSourceStatus | null;
}
